(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("3DpgH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a589d66c4793357$export$581ff339ea0ba762; });

var $c05mZ = parcelRequire("c05mZ");
function $2a589d66c4793357$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c05mZ._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRequire.register("c05mZ", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8bc9a678afa15efa$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $8bc9a678afa15efa$export$1e71eb4bef00f6b0; });
function $8bc9a678afa15efa$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("jIxMu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e5ac54a0c90d0848$export$4fa2f4023c9cbda5; });
function $e5ac54a0c90d0848$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e5ac54a0c90d0848$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $e5ac54a0c90d0848$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


var $6ZuWP = parcelRequire("6ZuWP");

var $9E0K6 = parcelRequire("9E0K6");

var $1Us1V = parcelRequire("1Us1V");


var $bQhDa = parcelRequire("bQhDa");
var $a8099c1663e60dc7$require$Buffer = $bQhDa.Buffer;
const $a8099c1663e60dc7$var$here = new (0, $6ZuWP.HereWallet)();
const $a8099c1663e60dc7$var$connectBtn = document.querySelector(".btn-connect-wallet");
const $a8099c1663e60dc7$var$renderMission = (item)=>{
    const isDisabled = item.status === 0 ? "disabled" : "";
    const isSuccess = item.status === 2 ? "success" : "";
    const href = isDisabled ? "<div " : `<a href="${item.link}"`;
    const style = item.title === "Aurora.Plus" ? "bottom:-16px;right: -14px;" : "";
    return `${href} class="cart-rainbow cart-item ${isDisabled} ${isSuccess}">
    <div class="cart-title">${item.title}</div>
    <div class="cart-description">${item.description.replaceAll("\n", "<br />")}</div>
    <div class="cart-transaction">
      <p>${item.score_description}:</p>
      ${isSuccess ? `<button class="success">Completed</button>` : `<button>+${item.score}</button>`}
    </div>
    <img class="logo" style="${style}" src="${item.image_url}" />
  ${isDisabled ? "</div>" : "</a>"}`;
};
const $a8099c1663e60dc7$var$fetchUser = async ()=>{
    $a8099c1663e60dc7$var$connectBtn.innerHTML = "Connect wallet";
    let url = `https://api.herewallet.app/partners/aurora/missions`;
    try {
        const auth = JSON.parse(localStorage.getItem("account"));
        const account = await $a8099c1663e60dc7$var$here.account(auth.account_id);
        $a8099c1663e60dc7$var$connectBtn.innerHTML = account.accountId.length > 16 ? account.accountId.slice(0, 8) + ".." + account.accountId.slice(-8) : account.accountId;
        url = `https://api.herewallet.app/partners/aurora/missions?account_id=${auth.account_id}`;
    } catch (e) {}
    const res = await fetch(url, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "GET"
    });
    const data = await res.json();
    console.log({
        data: data
    });
    const html = data.missions.map($a8099c1663e60dc7$var$renderMission).join("\n");
    const list = document.querySelector(".cart-section");
    list.innerHTML = html;
};
const $a8099c1663e60dc7$var$register = async ()=>{
    try {
        let nonceArray = new Uint8Array(32);
        const nonce = [
            ...crypto.getRandomValues(nonceArray)
        ];
        const result = await $a8099c1663e60dc7$var$here.signMessage({
            receiver: "HERE Wallet",
            message: "starbox",
            nonce: nonce
        });
        const auth = JSON.stringify({
            account_id: result.accountId,
            signature: (0, $9E0K6.base_encode)($a8099c1663e60dc7$require$Buffer.from(result.signature)),
            public_key: result.publicKey.toString(),
            nonce: nonce
        });
        localStorage.setItem("account", auth);
        $a8099c1663e60dc7$var$fetchUser();
    } catch (e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($1Us1V)))({
            text: "Authorization failed",
            position: "center",
            className: "here-toast"
        }).showToast();
    }
};
$a8099c1663e60dc7$var$connectBtn.addEventListener("click", async ()=>{
    localStorage.removeItem("account");
    $a8099c1663e60dc7$var$fetchUser();
    $a8099c1663e60dc7$var$register();
});
$a8099c1663e60dc7$var$fetchUser();
const $a8099c1663e60dc7$var$asks = Array.from(document.querySelectorAll(".section-faq__item"));
$a8099c1663e60dc7$var$asks.forEach((el)=>{
    el.addEventListener("click", ()=>{
        const header = el.querySelector(".section-faq__ask");
        const body = el.querySelector(".section-faq__answer");
        const headerBox = header.getBoundingClientRect();
        $a8099c1663e60dc7$var$asks.forEach((ask)=>{
            if (ask == el) return;
            const header = ask.querySelector(".section-faq__ask");
            const box = header.getBoundingClientRect();
            ask.classList.remove("open");
            ask.style.height = box.height + "px";
        });
        el.style.height = headerBox.height + "px";
        body.style.display = "block";
        setTimeout(()=>{
            const { height: height } = body.getBoundingClientRect();
            el.classList.toggle("open");
            el.style.height = el.classList.contains("open") ? `${headerBox.height + height}px` : headerBox.height + "px";
        }, 10);
    });
});

})();
//# sourceMappingURL=index.c17587a6.js.map
